import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { HoneycombGrid } from "@/components/HoneycombGrid";
import { Reveal } from "@/components/Reveal";
import { galleryImages } from "@/data/content";
import { useSiteContent } from "@/i18n/SiteContentContext";

export const GalleryPreview = () => {
  const { get } = useSiteContent();
  const images = get("gallery", galleryImages);
  return (
  <section id="gallery" data-testid="gallery-preview-section" className="honeycomb-bg relative overflow-hidden bg-mist py-28 md:py-40">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <SectionHeading
        number="06"
        eyebrow="The Fleet in Motion"
        title={<>A wall of <span className="text-royal/40">honeycombed miles.</span></>}
        description="Snapshots from the road — ports, plants, borders and everything in between."
      />
      <HoneycombGrid images={galleryImages.slice(0, 7)} />
      <Reveal className="mt-16 text-center">
        <Link to="/gallery" data-testid="gallery-view-all-btn" className="btn-premium">
          View Full Gallery <ArrowRight className="h-4 w-4" />
        </Link>
      </Reveal>
    </div>
  </section>
  );
};